import React, { useState } from "react";
import { MappingErrorIcon } from "./shared/MappingIcons";

const ColumnHeaderMappingWarning = (props) => {
  const columnName = props.columnName;
  const invalidWarnings = props.warningFilenames ?? [];
  const hasWarning = invalidWarnings.length > 0;
  const [showTooltip, setShowTooltip] = useState(false);

  const handleClick = () => {
    if (!props.inspect) return;
    props.inspect({
      column: {
        description: props.description || "",
        warnings: hasWarning ? invalidWarnings : null,
      },
    });
  };

  return (
    <div
      onClick={handleClick}
      onMouseEnter={() => props.showTooltip && hasWarning && setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      className="flex gap--8 align-items-center"
      style={{ position: "relative" }}
    >
      {hasWarning && <MappingErrorIcon />}
      {props.columnLabel}
      {props.showTooltip && showTooltip && (
        <div
          className="tooltip tooltip--top-right tooltip--fast tooltip--visible tooltip--fit"
          style={{
            top: "80px",
            left: 0,
          }}
        >
          <div className="tooltip__container">
            <div className="tooltip__container__subtitle t--orange">Unexpected column name</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ColumnHeaderMappingWarning;
